import type { ApiContext } from "@hobbyshopify/backend-client";
import { describeErrors } from "operation-result.js";
import type { AuthHandler } from "trunk.js";
import type { CountriesRepository } from "../repositories/countries-repository";
import type { BackendApi } from "./api";

/** Fetches the country table once; a loaded or in-flight repository is left alone. */
export async function loadCountries(o: {
  client: BackendApi;
  authHandler: AuthHandler<ApiContext>;
  countriesRepository: CountriesRepository;
}): Promise<void> {
  const repo = o.countriesRepository;
  if (repo.status.kind === "loading" || repo.status.kind === "loaded") return;
  repo.setLoading();
  const r = await o.authHandler.callApi((ctx) => o.client.geo.countries(ctx));
  if (!r.ok) {
    repo.setError(describeErrors(r.errors));
    return;
  }
  repo.setCountries(r.value);
}
